import styled from 'styled-components';

function gridPosition(props) {
  if (props.id) return `grid-area: ${props.id}`
}

const Box = styled.div`
  ${gridPosition}
`

export default Box;
